
import { defineComponent } from "vue";
import CatalogueSelectControl from "@/components/controls//base/CatalogueSelectControl.vue";
import DxButton from "devextreme-vue/button";
import { DxSelectBox } from "devextreme-vue";
import { DxCheckBox } from "devextreme-vue/check-box";
import api from "@/services/api";

export default defineComponent({
  components: {
    CatalogueSelectControl,
    DxButton,
    DxSelectBox,
    DxCheckBox,
  },
  props: { loading: { required: false } },
  methods: {
    async onFilterChange(){            
      const { data } = await api.get(
        `/LoadingReport/GetFilterValues`,
        {
          params: {
            planId: this.model.planId,
            containerId: this.containerId,
            schemeId: this.schemeId,
            orderId: this.selectedOptions.orderId,
            nomenclatureId: this.selectedOptions.nomenclatureId,
            nomenclatureName: this.selectedOptions.nomenclatureName,
            packageLength: this.selectedOptions.packageLength,
            packageCut: this.selectedOptions.packageCut,
          },
        }
      );
      this.options = (data as any);
    },
    getDataSource: async function (controller: any, idParent: any, desc: any) {
      const { data } = await api.get(`/${controller}/GetAll`, {
        params: {
          IdParent: idParent,
        },
      });
      const dataSource = (data as any).data.map((x: any) => {
        return {
          id: x.id,
          desc: x[desc],
        };
      });
      return dataSource;
    },
    async onPlanChange() {
      if (this.model.planId) {
        this.dataSourceContainer = await this.getDataSource(
          "PlanContainerResult",
          this.model.planId,
          "code"
        );
        this.showContainer = true;
        this.showScheme = false;        
        this.showOptions = true;
      } else {
        this.dataSourceContainer = null;
        this.showContainer = false;
        this.showScheme = false;
        this.options = {};
        this.showOptions = false;
      }
      this.selectedContainer = null;
      this.selectedScheme = null;
      this.selectedOptions = {};
      await this.onFilterChange();
    },
    async onContainerChange() {
      if (this.selectedContainer) {
        this.dataSourceScheme = await this.getDataSource(
          "PlanContainerResultLoadingScheme",
          this.selectedContainer.id,
          "number"
        );
        this.showScheme = true;        
      } else {
        this.showScheme = false;
        this.dataSourceScheme = null;
      }
      this.selectedScheme = null;
      this.selectedOptions = {};
      await this.onFilterChange();
    },
    async onSchemeChange(){      
      this.selectedOptions = {};
      await this.onFilterChange();
    },
    onButtonClick() {
      if (this.loading)
        this.onStop();
      else this.onReport;
    },
    onReport() {
      this.$emit(
        "onReport",
        this.model.planId,
        this.selectedOptions,
        this.containerId,
        this.schemeId,
        this.showName,
      );
    },
    onDownload() {
      this.$emit(
        "onDownload",
        this.model.planId,
        this.selectedOptions,
        this.containerId,
        this.schemeId,
        this.showName,
      );
    },
    onStop() {
      this.$emit("onStop");
    },
    setModel(model: any) {
      this.model = model;
      this.onReport();
    },
  },
  computed: {
    containerId(): any {
      return this.selectedContainer?.id;
    },
    schemeId(): any {
      return this.selectedScheme?.id;
    }
  },
  data() {
    return {
      showName: true,
      dataSourceContainer: null,
      dataSourceScheme: null,
      selectedContainer: null,
      selectedScheme: null,
      showContainer: false,
      showScheme: false,
      model: {},
      showOptions: false,
      options: {
        order: null,
        nomenclatureLine: null,
        nomenclature: null,
        packageLength: null,
        packageCut: null,
      },
      selectedOptions: {
        orderId: null,
        nomenclatureId: null,
        nomenclatureName: null,
        packageLength: null,
        packageCut: null,
      },
      nomenclatureList: null,
      orderList: null,
    };
  },
});
